
/* 首页导航配置  */

/*
chaopx.com/list/{pinyin}-{home_keyword_id}-{layout}-{time_filter}-{module}-{desc}-{page}.html

1	元素
2	背景
3	电商
4	插画
5	平面
6	3D
7	UI
8	摄影图
9	艺术字
* */

/*1 平面
2 3D
3 电商
4 UI
5 插画
6 元素
7 背景
8 艺术字*/
import {MATERIAL_LIST_CUSTOM} from "@/constant/PATH";

export const menuNavList = [
  {
    name:"全部",
    id:0,
    className:"all",
    url:MATERIAL_LIST_CUSTOM + '/0-0-0-0-0-0-default-1.html',
    bgColor:"",
    hoverBgColor:"#17A1FF"
  },
  {
    name:"平面",
    id:5,
    url:MATERIAL_LIST_CUSTOM + '/0-0-0-0-5-0-default-1.html',
    className: "plane",
    bgColor:"",
    hoverBgColor:"#FA4633"
  },
 /* {
    name:"3D",
    id:6,
    className:"model",
    url:MATERIAL_LIST_CUSTOM + '/0-0-0-0-6-0-default-1.html',
    bgColor:"",
    hoverBgColor:"#00CFDD"

  },*/
  {
    name:"电商",
    id:3,
    className:"business",
    url:MATERIAL_LIST_CUSTOM + '/0-0-0-0-3-0-default-1.html',
    bgColor:"",
    hoverBgColor:"#EF2B79"
  },
  {
    name:"UI",
    id:7,
    url:MATERIAL_LIST_CUSTOM + '/0-0-0-0-7-0-default-1.html',
    className: "ui",
    bgColor:"",
    hoverBgColor:"#FA4633"
  },
  {
    name:"插画",
    id:4,
    className:"illustration",
    url:MATERIAL_LIST_CUSTOM + '/0-0-0-0-4-0-default-1.html',
    bgColor:"",
    hoverBgColor:"#FF9400"
  },
  {
    name:"元素",
    id:1,
    url:MATERIAL_LIST_CUSTOM + '/0-0-0-0-1-0-default-1.html',
    className: "element",
    bgColor:"",
    hoverBgColor:"#FA4633"
  },
  {
    name:"背景",
    id:2,
    url:MATERIAL_LIST_CUSTOM + '/0-0-0-0-2-0-default-1.html',
    className: "background",
    bgColor:"",
    hoverBgColor:"#FA4633"
  },
  {
    name:"艺术字",
    id:9,
    className:"wordart",
    url:MATERIAL_LIST_CUSTOM + '/0-0-0-0-9-0-default-1.html',
    bgColor:"",
    hoverBgColor:"#FFC001"
  },

]


/* 场景列表 */
export const sceneList = [
  {
    label:'全部',
    id:0,
  },
  {
    label:'电商促销',
    id:1,
  },
  {
    label:'餐饮美食',
    id:3,
  },
  {
    label:'企业商务',
    id:7,
  },
  {
    label:'教育培训',
    id:4,
  },
  {
    label:'医疗健康',
    id:5,
  },
  {
    label:'美容美妆',
    id:6,
  },
  {
    label:'休闲娱乐',
    id:15,
  },
  {
    label:'酒店旅游',
    id:10,
  },
  {
    label:'地产家居',
    id:9,
  },
  {
    label:'行业招聘',
    id:2,
  },
  {
    label:'金融理财',
    id:8,
  },
  {
    label:'母婴亲子',
    id:12,
  },
  {
    label:'体育健身',
    id:13,
  },
  {
    label:'公益宣传',
    id:16,
  },
  {
    label:'汽车服务',
    id:11,
  },
  {
    label:'通用',
    id:14,
  }

]
